
import { Vue, Component } from 'vue-property-decorator'
import Config from '@/config'
import PackageCheckoutQueries from '../../../../../tradingmate-modules/src/models/common/PackageCheckoutQueries'
import Heading from '@/components/typography/Heading.vue'
import VerticalHeading from '@/components/typography/VerticalHeading.vue'

@Component({
  components: {
    VerticalHeading,
    Heading
  }
})

export default class PackagesV2 extends Vue {
  // Handle CTA clicks
  private onCtaClick (packageQuery: string): void {
    const url = Config.WebsiteUrls.Console + '/account/register' + '?p=' + packageQuery
    window.open(url, '_self')
  }

  private onB2bClicked (): void {
    this.onCtaClick(PackageCheckoutQueries.B2b)
  }

  private onStatewideClicked (): void {
    this.onCtaClick(PackageCheckoutQueries.StateWide)
  }

  private onWebsiteClicked (): void {
    this.onCtaClick(PackageCheckoutQueries.Website)
  }

  private onPromoClicked (): void {
    this.onCtaClick(PackageCheckoutQueries.Promo)
  }

  private onNationalClicked (): void {
    this.onCtaClick(PackageCheckoutQueries.AllAussieExtra)
  }
}
